module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "m-navbar navbar-bottom-line-color border2",
    class: _vm.classes,
    style: ({
      backgroundColor: _vm.bgcolor
    })
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "navbar-center-box"
  }, [_c('div', {
    staticClass: "navbar-center"
  }, [(_vm.type == 'center') ? [_vm._t("center", [_c('span', {
    staticClass: "center-title",
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.title))])])] : [_vm._t("center", [_c('span', {
    staticClass: "top-title",
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "tips",
    style: ({
      color: _vm.tipsColor
    })
  }, [_vm._v(_vm._s(_vm.tips))])])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c55066b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 611
// module chunks = 1